import { createContext, useContext } from 'react';

export type LiveSlideControlContextValue = {
  entityType: string;
  entityId: string;
};

const LiveSlideControlContext = createContext<LiveSlideControlContextValue | null>(null);

export function LiveSlideControlProvider({
  value,
  children,
}: {
  value: LiveSlideControlContextValue | null;
  children: React.ReactNode;
}) {
  return <LiveSlideControlContext.Provider value={value}>{children}</LiveSlideControlContext.Provider>;
}

export function useLiveSlideControlContext() {
  return useContext(LiveSlideControlContext);
}
